import styled from 'styled-components';

export const StyledSelect = styled.select`
  font-size: 1em;
  font-family: inherit;
`;
